import React from 'react';
import { Box, Grid, Chip } from '@mui/material';
import ScrollContainer from 'react-indiana-drag-scroll';

import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';

type TProps = {
  handleSelectType: (type: string) => void;
  type: string;
};

const typeList: { id: string }[] = [
  {
    id: 'UNREAD',
  },
  {
    id: 'INFO',
  },
  {
    id: 'ERROR',
  },
  {
    id: 'WARNING',
  },
  {
    id: 'CRITICAL',
  },
];

const TypeTabNotification = (props: TProps) => {
  const { handleSelectType, type } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const handleSelectTypeItem = (typeSelected: string) => {
    handleSelectType(typeSelected);
  };

  return (
    <Box p={1} overflow="hidden" className={classes.root}>
      <ScrollContainer className="scroll-container" hideScrollbars>
        <Grid container flexWrap="nowrap">
          {typeList.map((item) => {
            return (
              <Grid item key={item.id} mr={1}>
                {/* <Button
                  variant={type.includes(item.id) ? 'contained' : 'outlined'}
                  size="small"
                  onClick={() => handleSelectTypeItem(item.id)}
                >
                  {item.value}
                </Button> */}
                <Chip
                  label={t(`notification.chip.${item.id}`)}
                  color="primary"
                  variant={type === item.id ? 'filled' : 'outlined'}
                  onClick={() => handleSelectTypeItem(item.id)}
                  sx={{ borderRadius: 2 }}
                />
              </Grid>
            );
          })}
        </Grid>
      </ScrollContainer>
    </Box>
  );
};

export default TypeTabNotification;
